import { useEffect } from "react";

import ViewDocuments from "../../../../../components/modules/Documents/ViewDocuments";
import Navigation from "../../../../../components/navigations/client/detail/documents/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(2);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/documents/folders");
  }, []);

  return (
    <Navigation activeTab="folders" _case={_case}>
      <ViewDocuments />
    </Navigation>
  );
};
